var map = {
	"./en/king_card_title.png": "buT3",
	"./es/king_card_title.png": "cURV",
	"./pt/king_card_title.png": "oNXc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3Bc8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/king_card_title\.png$
// module id = 3Bc8
// module chunks = 0